import { atom } from 'recoil';

export const adminState = atom({
  key: 'adminState', // unique ID (with respect to other atoms/selectors)
  default: {}, // default value (aka initial value)
});

export const formStatusesState = atom({
  key: 'formStatusesState',
  default: [],
});